import API_URL from "../apiConfig";

export default async function apiFetch(path, options = {}) {
  const headers = new Headers(options.headers || {});
  const isFormData =
    typeof FormData !== "undefined" && options.body instanceof FormData;

  let body = options.body;

  if (body !== undefined && body !== null && !isFormData) {
    if (typeof body !== "string") {
      body = JSON.stringify(body);
    }

    if (!headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json");
    }
  }

  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers,
    body,
    credentials: "include",
  });

  if (response.status === 204) return null;

  const text = await response.text().catch(() => "");
  let data = {};

  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { raw: text };
  }

  if (!response.ok) {
    const error = new Error(
      data?.message || data?.error || text || "Error en la petición"
    );
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}
